import React from "react";

const usd = (value) =>
  Number(value || 0).toLocaleString(undefined, { style: "currency", currency: "USD", minimumFractionDigits: 2 });

// Total held across partners, in USD (the latest balance per partner and
// currency, each priced in USD with a USDT/USDC fallback). A currency with no
// rate is left out and named; an old snapshot is called out so the total is
// not mistaken for live.
function PartnerBalancesUsdSummary({ summary, isLoading, isError, filteredTotal, filtered }) {
  if (isError) {
    return (
      <p className="px-4 py-3 mb-4 text-sm text-red-700 bg-red-50 rounded border border-red-100">
        Could not load the USD total.
      </p>
    );
  }

  const oldest = summary?.oldestCapturedAt ? new Date(summary.oldestCapturedAt) : null;
  const ageHours = oldest ? (Date.now() - oldest.getTime()) / 36e5 : 0;

  return (
    <div className="mb-4">
      <div className="flex flex-wrap gap-x-8 gap-y-3 items-start px-4 py-3 rounded border border-gray-200 bg-gray-50/50">
        <div>
          <div className="text-xs font-bold tracking-wider text-gray-500 uppercase">Total partner balance (USD)</div>
          <div className="text-xl font-semibold text-gray-900">{isLoading || !summary ? "..." : usd(summary.totalUsd)}</div>
          {filtered && summary && (
            <div className="mt-0.5 text-xs text-gray-500">Shown with the filters: {usd(filteredTotal)}</div>
          )}
        </div>
        {summary?.byPartner?.length > 0 && (
          <div className="flex flex-wrap gap-x-6 gap-y-1 items-center text-sm">
            {summary.byPartner.map((p) => (
              <div key={p.partner}>
                <span className="text-gray-500 capitalize">{p.partner.toLowerCase()}: </span>
                <span className="font-medium text-gray-900">{usd(p.usd)}</span>
              </div>
            ))}
          </div>
        )}
      </div>
      {summary?.unpricedCurrencies?.length > 0 && (
        <div className="mt-2 text-xs text-red-600">
          <p>Not included, no USD, USDT, USDC or CoinMarketCap rate available:</p>
          <ul className="mt-1 ml-4 list-disc">
            {summary.unpricedCurrencies.map((c) => (
              <li key={c}>
                <span className="font-medium">{c}</span>
                {summary.unpricedReasons?.[c] && <span className="text-red-500"> ({summary.unpricedReasons[c]})</span>}
              </li>
            ))}
          </ul>
        </div>
      )}
      {oldest && ageHours > 24 && (
        <p className="mt-2 text-xs text-amber-700">
          The oldest balance behind this total was captured {oldest.toLocaleString()}. Use Refresh all to update.
        </p>
      )}
    </div>
  );
}

export default PartnerBalancesUsdSummary;
